import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as r } from "react";
const c = ({
  title: o,
  titleId: l,
  ...s
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": l,
    ...s,
    children: [
      o ? /* @__PURE__ */ e.jsx("title", { id: l, children: o }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M748.22 797.09H438.695V634.183h81.457c48.871 0 81.457-32.581 81.457-81.457s-32.58-81.457-81.457-81.457h-81.457V308.361c0-48.87 32.58-81.456 81.457-81.456s81.457 32.58 81.457 81.456c0 48.871 32.58 81.457 81.457 81.457s81.457-32.58 81.457-81.457c0-138.472-105.892-244.364-244.365-244.364S275.793 169.889 275.793 308.361v162.908c-48.871 0-81.457 32.581-81.457 81.457s32.58 81.457 81.457 81.457V797.09c-48.871 0-81.457 32.581-81.457 81.457s32.58 81.457 81.457 81.457h472.439c48.871 0 81.457-32.581 81.457-81.457s-40.725-81.457-81.457-81.457z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m = r(c);
export {
  m as default
};
